import { createAnalyticsMiddleware, createAnalyticsReducer } from 'common/analytics'

const eventsMap = {}

export const analyticsMiddleware = createAnalyticsMiddleware(eventsMap, true)

export const analyticsReducer = createAnalyticsReducer(eventsMap, true)
